var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from "react";
import { fixedForwardRef } from "../../../common/LibComponentProps";
import { CollapseContext } from "../../core";
import { useHeaderContext } from "../Header";
var UnwrappedNavigationLink = function (props, ref) {
    var _a = props.as, Component = _a === void 0 ? "a" : _a, _b = props.isCurrentPage, isCurrentPage = _b === void 0 ? false : _b, children = props.children, className = props.className, style = props.style, onClick = props.onClick, otherProps = __rest(props, ["as", "isCurrentPage", "children", "className", "style", "onClick"]);
    var collapseContextValue = useContext(CollapseContext);
    var closeCollapse = undefined;
    if (collapseContextValue) {
        closeCollapse = collapseContextValue.closeCollapse;
    }
    var headerContextValue = useHeaderContext();
    var closeMenu = undefined;
    if (headerContextValue && headerContextValue.setIsOpenMenu) {
        closeMenu = function () { return headerContextValue.setIsOpenMenu(false); };
    }
    var navigationLinkClass = "fr-nav__link";
    if (className) {
        navigationLinkClass += " ".concat(className);
    }
    var onClickNavLink = function (event) {
        if (closeCollapse) {
            closeCollapse();
        }
        if (closeMenu) {
            closeMenu();
        }
        if (onClick) {
            onClick(event);
        }
    };
    return (React.createElement(Component, __assign({}, otherProps, { ref: ref, className: navigationLinkClass, style: style, "aria-current": isCurrentPage ? "page" : undefined, onClick: onClickNavLink }), children));
};
var NavigationLink = fixedForwardRef(UnwrappedNavigationLink);
export default NavigationLink;
